import Cookie from 'js-cookie'

const timezone_key = 'prefer_timezone'

export class Timezoner {
  set prefer(timezone: string) {
    const options =
      process.env.NODE_ENV === 'test'
        ? undefined
        : {
            domain: '.' + location.hostname,
            expires: 365
          }
    Cookie.set(timezone_key, timezone, options)
  }

  get prefer() {
    return Cookie.get(timezone_key) || Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  forget() {
    Cookie.remove(timezone_key)
  }
}

export const timezoner = new Timezoner()
